// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"51":"plone-volto-components-manage-Controlpanels-Aliases","454":"Widgets","637":"Form","821":"plone-volto-components-theme-InjectPloneComponentsCSS-InjectPloneComponentsCSS"}[chunkId] + "." + {"51":"62da82f2","454":"62da82f2","637":"61275d32","821":"9b025ce8"}[chunkId] + ".chunk.css";
};